import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { ColorUnit } from '../create-label/components/color-unit';
import * as Styled from './styles';
import * as SX from './sx';
import type { LabelColorPickerProps as Props } from './types';

export const LabelColorPicker = memo(
  ({ className, colors, handleColorChange }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('LabelColorPicker', className)}
        sx={SX.root}
      >
        <Typography sx={SX.label}>Select Label Color</Typography>

        <Grid2 container>
          {colors.map((color, index) => (
            <Grid2 xs={12} sm={6} md={3} lg={3} key={index}>
              <ColorUnit
                key={color.value}
                color={color}
                handleColorChange={handleColorChange}
              />
            </Grid2>
          ))}
        </Grid2>
      </Styled.Wrapper>
    );
  }
);

LabelColorPicker.displayName = 'LabelColorPicker';
